import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyManureAdditive } from "services";

import { FOOTPRINTING_CROP, FOOTPRINTING_DAIRY_MANURE_ADDITIVE } from "consts";

import { FootprintingDairyManureAdditivePayload } from "models";

export const useMutateFootprintingDairyManureAdditive = (
  farmId: string,
  year: number,
  payload: FootprintingDairyManureAdditivePayload,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_MANURE_ADDITIVE],
      mutationFn: () => setFootprintingDairyManureAdditive(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_DAIRY_MANURE_ADDITIVE, primaryDataId],
          [FOOTPRINTING_CROP, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
